import BossModel from "@/models/BossModel";

export default class Item extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-widget/accordion/item';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteWidgetAccordionItems';

    static fields() {
		return {
			id: this.number(null).nullable(),
			rank: this.number(null).nullable(),
			title: this.attr(null),
			text: this.attr(null),
			website_widget_accordion_id: this.number(null).nullable(),
			created_at: this.attr(null),
			updated_at: this.attr(null),
		}
	}

    /**
     *
     * @param sliderId
     * @returns {*}
     */
    static fetchByAccordionId(sliderId) {
        return this.api()
            .limit(0)
            .where('website_widget_accordion_id', sliderId)
            .get(true);
    }
}
